export default __webpack_public_path__ + "static/media/summerchallenge13.2e2d1f36.jpg";